import React, { useContext } from 'react';

import './mediaContentBlock.scss';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import Button from '../Button/button';
import {
  ButtonComponentStyles,
  getFilteredMedia,
  getLimitedMedia,
  downloadMedia,
  previewMediaUrl,
  renderFormattedDateTime,
  ALL_CATEGORIES_DEFAULT,
} from '../../utils/utils';
import Modal from '../Modal/refLibModal';
import { AppControlContext } from '../../context/AppControlContext';
import clientConfig from '../../../client-config';

const MediaContentBlock = ({ mediaData, selectedCategory = ALL_CATEGORIES_DEFAULT, dataLimit, ...props }) => {
  const [initialData, setInitialData] = React.useState(dataLimit);
  const [mediaContent, setMediaContent] = React.useState(null);
  const [isCategorySelected, setIsCategorySelected] = React.useState(false);
  const { setModalIsOpen, modalIsOpen } = React.useContext(AppControlContext);
  const showData =
    selectedCategory !== ALL_CATEGORIES_DEFAULT ? getFilteredMedia(mediaData, selectedCategory) : getLimitedMedia(mediaData, initialData);

  const { setBlogList, setSelectedBlog } = useContext(AppControlContext);

  React.useEffect(() => {
    setBlogList(mediaData);
  }, [mediaData]);

  React.useEffect(() => {
    if (selectedCategory !== ALL_CATEGORIES_DEFAULT) {
      setIsCategorySelected(true);
    } else {
      setIsCategorySelected(false);
    }
  }, [selectedCategory]);

  function openModal(e, media) {
    e.preventDefault();
    setMediaContent(media);
    setModalIsOpen(true);
  }

  const seeMoreDataHandle = () => {
    setInitialData(showData.length + dataLimit);
  };

  const renderMedia = (showData) => {
    return showData?.length > 0 ? (
      showData.map((media) => {
        return (
          <div className="media-block-column" key={media.mediaType}>
            <div className="media-block">
              <a
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  openModal(e, media);
                }}
              >
                <div className="media-img fit-img-height">
                  <Img
                    fluid={getFluidGatsbyImage(media.imgSource ? media.imgSource : media.fallbackImgSource, { maxWidth: 675 }, clientConfig.sanity)}
                    alt="alt"
                  />
                </div>
              </a>
              <div className="img-block-desc">
                <h4 className="media-title">{media.category}</h4>
                <div className="media-desc">
                  <p>{media.description}</p>
                </div>
                <div className="media-footer">
                  <small>
                    Download
                  </small>
                  {media.showDownloadButton ? (
                    <a
                      className="icon-wrap"
                      onClick={(e) => {
                        e.preventDefault();
                        downloadMedia(media);
                      }}
                    >
                      <i className="icon-download" />
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div>No Media Found!</div>
    );
  };

  const renderBlogs = (showData) => {
    return showData?.length > 0 ? (
      showData.map((blog) => {
        return (
          <div className="media-block-column" key={blog.id}>
            <div className="media-block">
              <a>
                <div className="media-img fit-img-height">
                  <Img fluid={getFluidGatsbyImage(blog.featureImage ? blog.featureImage : blog.fallbackImgSource, { maxWidth: 675 }, clientConfig.sanity)} alt="alt" />
                </div>
              </a>
              <div className="img-block-desc">
                <div className="media-desc">
                  <p>{blog.title}</p>
                </div>
                <div
                  className="media-footer"
                  onClick={() => {
                    setSelectedBlog(blog);
                  }}
                >
                  <small>{renderFormattedDateTime(blog.date)}</small>
                  <Link to={`/blog/${blog?.blogSlug}/`} className="icon-wrap arrow-btn">
                    Read Now <i className="icon-arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div>No Post Found!</div>
    );
  };

  const renderNews = (showData) => {
    return showData?.length ? (
      showData.map((news) => {
        return (
          <div className="media-block-column" key={news.id}>
            <div className="media-block">
              <a>
                <div className="media-img fit-img-height">
                  <Img fluid={getFluidGatsbyImage(news.featureImage, { maxWidth: 675 }, clientConfig.sanity)} alt="alt" />
                </div>
              </a>
              <div className="img-block-desc">
                <div className="media-desc">
                  <p>{news.title}</p>
                </div>
                <div className="media-footer">
                  <small>{renderFormattedDateTime(news.date)}</small>
                  <Link to={`/news/${news?.newsSlug}/`} className="icon-wrap arrow-btn">
                    Read Now <i className="icon-arrow" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        );
      })
    ) : (
      <div>No News Found!</div>
    );
  };

  return (
    <>
      <div className="media-wrapper">
        {(() => {
          if (props.isMedia) {
            return renderMedia(showData);
          }
          if (props.isBlogs) {
            return renderBlogs(showData);
          }
          if (props.isNews) {
            return renderNews(showData);
          }
        })()}
      </div>
      {initialData < mediaData.length && !isCategorySelected ? (
        <div className="text-center">
          <Button title="Load More" buttonStyle={ButtonComponentStyles.OUTLINE} onClicked={seeMoreDataHandle} />
        </div>
      ) : null}

      {modalIsOpen ? (
        <Modal>
          <iframe
            className=""
            src={previewMediaUrl(mediaContent.mediaUrlSource)}
            id="video"
            allowscriptaccess="always"
            allow="autoplay"
            title="ld"
            width="100%"
            height="400"
          />
        </Modal>
      ) : (
        ''
      )}
    </>
  );
};
export default MediaContentBlock;
